import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import ShopLogin from './pages/ShopLogin';
import HeadOfficePricing from './pages/Shop/HeadOfficePricing';
import HeadOfficeMyPricing from './pages/Shop/HeadOfficeMyPricing';
import ForgotPassword from './pages/ForgotPassword';
import HeadOfficeChangeMyPricing from './pages/Shop/HeadOfficeChangeMyPricing';
import VerifyPayment from './pages/VerifyPayment';
import NotFoundPage from './pages/404';
import GuestRoute from './routes/GuestRoute';
import AddNewService from './pages/Shop/AddNewService';
import ManagerDashboard from './pages/Manager/ManagerDashboard';
import { HelmetProvider } from 'react-helmet-async';
import EquipmentRentals from './pages/EquipmentRentals';
import UploadFiles from './pages/UploadFiles';
import OnBoarding from './pages/OnBoarding';
import Settings from './pages/Shop/Settings';
import { AuthProvider } from "./contexts/AuthContext";
import ManagerRoute from './routes/ManagerRoute';
import RestrictedRoute from './routes/RestrictedRoute';
import PolicyPage, { PoliciesIndex } from './pages/Policies';
import V2PublicSite from './v2/V2PublicSite';
import V2Dashboard from './v2/V2Dashboard';
import V2AdminDashboard from './v2/V2AdminDashboard';
import VerifyApprovedListingPayment from './pages/VerifyApprovedListingPayment';


function App() {
  return (
    <AuthProvider>
      <HelmetProvider>
        <Router>
          <Routes>
            {process.env.REACT_APP_V2_E2E === "true" && (
              <>
                <Route path="/__e2e/v2/dashboard" element={<V2Dashboard />} />
                <Route path="/__e2e/v2/admin" element={<V2AdminDashboard />} />
              </>
            )}
            {/* Public Routes */}
            <Route path="/" element={<V2PublicSite page="home" />} />
            <Route path="/marketplace" element={<V2PublicSite page="marketplace" />} />
            <Route path="/about" element={<V2PublicSite page="about" />} />
            <Route path="/pricing" element={<V2PublicSite page="pricing" />} />
            <Route path="/file-check" element={<V2PublicSite page="file-check" />} />
            <Route path="/secret-marketplace" element={<Navigate to="/marketplace" replace />} />
            <Route path="/marketplace/upload" element={<UploadFiles />} />
            <Route path="/onboarding/plan" element={<OnBoarding />} />
            <Route path="/demo-signup" element={<Navigate to="/onboarding/plan" replace />} />
            <Route path="/register-print-shop" element={<Navigate to="/onboarding/plan" replace />} />
            <Route path="/checkout" element={<Navigate to="/marketplace" replace />} />
            <Route path="/printing-jobs" element={<Navigate to="/marketplace" replace />} />
            <Route path="/custom-quote" element={<Navigate to="/marketplace" replace />} />
            <Route path="/stores" element={<Navigate to="/marketplace" replace />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/compare-prices" element={<Navigate to="/marketplace" replace />} />
            <Route path="/verify-payment" element={<VerifyPayment />} />
            <Route path="/verify-approved-payment" element={<VerifyApprovedListingPayment />} />
            <Route path="/demo-verify-payment" element={<Navigate to="/onboarding/plan" replace />} />
            <Route path="/verify-online-payment" element={<Navigate to="/marketplace" replace />} />
            <Route path="/contact" element={<V2PublicSite page="contact" />} />
            <Route path="/policies" element={<PoliciesIndex />} />
            <Route path="/acceptable-use-policy" element={<PolicyPage policyKey="acceptable" />} />
            <Route path="/shipping-policy" element={<PolicyPage policyKey="shipping" />} />
            <Route path="/returns-policy" element={<PolicyPage policyKey="returns" />} />
            <Route path="/equipment-rentals" element={<EquipmentRentals />} />

            <Route element={<GuestRoute />}>
              <Route path="/shop-login" element={<ShopLogin />} />
            </Route>

            {/* Protect shop routes with RestrictedRoute */}
            <Route element={<RestrictedRoute allowedTypes={["printShop"]} />}>
              <Route path="/shop/dashboard" element={<V2Dashboard />} />


              <Route path="/admin/pricing" element={<HeadOfficePricing />} />
              <Route path="/admin/add-new-service" element={<AddNewService />} />
              <Route path="/admin/my-pricing" element={<HeadOfficeMyPricing />} />
              <Route path="/admin/change-my-pricing" element={<HeadOfficeChangeMyPricing />} />

            </Route>

            <Route element={<RestrictedRoute allowedTypes={["printShop"]} />}>
              <Route path="/shop/job-details" element={<V2Dashboard />} />
              <Route path="/shop/closed-jobs" element={<V2Dashboard />} />
              <Route path="/shop/analytics" element={<V2Dashboard />} />

            </Route>

            <Route element={<RestrictedRoute allowedTypes={["supplier", "specialist"]} />}>
              <Route path="/supplier/dashboard" element={<V2Dashboard />} />

            </Route>

            <Route element={<RestrictedRoute allowedTypes={["supplier", "specialist", "printShop"]} />}>
              <Route path="/supplier/enquiries" element={<V2Dashboard />} />
            </Route>


            {/* <Route element={<RestrictedRoute allowedTypes={["printShop"]} />}>
                <Route path="/both/dashboard" element={<BothDashboard />} />

              </Route> */}

            <Route element={<RestrictedRoute allowedTypes={["printShop", "supplier", "specialist"]} />}>
              <Route path="/shop/settings" element={<Settings />} />

            </Route>

            <Route element={<RestrictedRoute allowedTypes={["admin"]} />}>
              <Route path="/admin/dashboard" element={<V2AdminDashboard />} />
              <Route path="/admin/view-all-shops" element={<V2AdminDashboard />} />
            </Route>



            <Route element={<ManagerRoute />}>

              <Route path="/manager/dashboard" element={<ManagerDashboard />} />

            </Route>


            {/* Catch-All Route: Keep this at the bottom */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Router>
      </HelmetProvider>
    </AuthProvider>
  );
}

export default App;
